<style lang="stylus">
// $basecolor = #1890ff

.locationpanelwrap
  font-size: 14px
  position: relative
  z-index:99
  .locationselecttitle
    width: 100%
    height: 100%
    display: flex
    align-items: center
  .locationpanel
    position: absolute
    top: 115%
    left: 0
    width: 500px
    padding: 8px 22px
    cursor: initial
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 10px 0px rgba(39,81,203,0.09);
    .locationhead
      line-height: 34px
      padding: 0 0 0 5px
      color: #303030
      border-bottom: 1px solid #e5e5e5
      font-weight: bold
      .addressicon
        color: $basecolor
        margin: 0 7px 0 25px
      .closeicon
        font-size: 20px
        float: right
        height: 100%
        width: 50px
        line-height: 60px
        cursor: pointer
        text-align: center
    .locationbody
      padding: 20px 0
      .hotcity
        li
          text-align: center
          margin: 0 0 8px
          a
            color: #666666
            &:hover, &.active
              color: #0050b3 !important
              font-weight: bold
        .ivu-col:first-child
          li
            a
              color: #000
      .ivu-cascader-label
        cursor: text
      .ivu-cascader-menu
        min-width 170px !important
        .ivu-cascader-menu-item
          overflow hidden
          // text-overflow ellipsis
          white-space: nowrap !important
      .ivu-select-item
        overflow hidden
        white-space: nowrap !important
      .locationjzdw
        color: #303030
        font-weight: bold
        line-height: 32px
</style>

<template>
  <div :class="{active: locationpanel}" class="locationpanelwrap" style="padding: 0" v-clickOutSide="closelocationpanel">
    <div @click="togglelocationpanel" class="locationselecttitle">
      <slot></slot>
    </div>
    <div v-if="locationpanel" class="locationpanel floatpanel">
      <div class="locationhead">热门城市</div>
      <div class="locationbody">
        <ul class="hotcity">
          <el-row>
            <el-col :span="3" v-for="list in hotcity" :key="list[list.length - 1]">
              <li><a @click="changelocation(list)" :class="{active: selectlocation[selectlocation.length - 1] === list[list.length - 1] }" href="javascript:;">{{list[list.length - 1]}}</a></li>
            </el-col>
          </el-row>
        </ul>
      </div>
      <div class="locationhead"></div>
      <div class="locationbody">
        <el-row :gutter="8">
          <el-col :span="4">
            <p class="locationjzdw">精准定位</p>
          </el-col>
          <el-col :span="16"><!-- change-on-select -->
            <el-cascader
              v-model="selectlocal"
              :options="cityData"
              @onChangeQueryWord="onChangeQueryWord"
              placeholder="输入 / 选择您的城市"
              filterable
              :props="{checkStrictly : true}"
              size="small"
              style="width: 96%;"
              v-loading="loadingCityData"
              element-loading-spinner="el-icon-loading"
            ></el-cascader>
          </el-col>
          <el-col :span="4">
            <el-button @click="changelocation(false)" type="primary" size="small" style="width: 100%;">确 定</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectCity',
  data() {
    return {
      locationpanel: false,
      selectlocation: [],
      selectlocal: [],    //下拉框
      isselect: 0,
      hotcity: [
        ['全国'],
        ['北京市'],
        ['上海市'],
        ['广东省', '广州市'],
        ['广东省', '深圳市'],
        ['浙江省', '杭州市'],
        ['四川省', '成都市'],
        ['重庆市'],
        ['福建省', '厦门市'],
        ['天津市'],
        ['陕西省', '西安市'],
        ['江苏省', '南京市'],
        ['湖南省', '长沙市'],
        ['湖北省', '武汉市'],
        ['山东省', '青岛市'],
        ['广西壮族自治区', '南宁市']
      ],
      loadingCityData: true,
      querylocal: '',
      time:''
    }
  },
  computed: {
    placeData() {
      return this.$store.state.placeData;
    },
    // selectlocation(){
    //   return this.$store.state.locationCity;
    // }
  },
  beforeMount() {
    this.getCityInfo();
    this.selectlocation = this.$store.state.locationCity;
    this.getuserip();
  },
  methods: {
    togglelocationpanel() {
      this.locationpanel = !this.locationpanel;
      if( !this.locationpanel ){
        this.selectlocal = [];
      }
    },
    closelocationpanel() {
      this.locationpanel = false;
      this.selectlocal = [];
    },
    getCityInfo() {
      this.$ajax('get', 'district/getdistrictjson', (data) => {
        let city = JSON.parse(data.data.district);
        this.$store.commit('changePlaceData', JSON.parse(data.data.district));
        city.forEach(e => {
          if( e.value == "北京市" || e.value == "天津市" ||  e.value == "上海市" ||  e.value == "重庆市" ||  e.value == "台湾省" || e.value == "香港特别行政区" || e.value == "澳门特别行政区" ){
            let ch = e.children.map(f => f.children);
            e.children = ch[0];
          }else{
            e.children.forEach(f => {
              delete f.children;
            });
          }
          e.children.unshift({"value":"","label":"全部地区"});
        });
        // this.$store.commit('changePlaceData', city);
      });
    },
    changelocation(v) {
      v = v ? v.filter(e => e) : false;
      if( v ){    // 直接选择城市
        this.selectlocation = v;
        this.isselect = 1;
        this.selectlocal = [];
      }else{      // 通过选择框选择 也就是点了确定按钮
        // setTimeout(() => {
          if( this.selectlocal.length ){  // 选择了
            this.selectlocation = this.selectlocal.filter(e => e);
            this.isselect = 1;
          }else{    // 没选择
            // 没选择时判断搜索词是否有效 无效则不执行操作
            if( this.querylocal.length > 1 ){  // 搜索词大于一个字
              // 请求真实地址
              this.$ajax('get', 'district/addressresolution', { address: this.querylocal}, (data) => {
                let arr = data.address.split('-');
                if( arr.length >= 2 && arr[0] == arr[1]){
                  arr.shift();
                }
                this.selectlocation = arr;
                this.isselect = 1;
              });
            }else{  // 一个字或以下
              this.$message.error('无效的地址，无法进行搜索！');
            }
          }
          this.querylocal = '';
          this.selectlocal = [];
        // }, 400);
      }
      this.locationpanel = false;
    },
    onChangeQueryWord(word) {
      if( word ){
        this.selectlocal = [];
        this.querylocal = word;
      }
    },
    getuserip() {
      let defaultlocation = ['广东省', '深圳市'];
      this.$ajax('get', 'getip', data => {
        if( data.ip_province !== '' && data.ip_city !== '' ){
          defaultlocation = [data.ip_province, data.ip_city];
        }
        this.selectlocation = defaultlocation;
        console.log('1111',this.selectlocation);
      }, err => {
        this.selectlocation = defaultlocation;
      });
    },
  },
  watch: {
    selectlocation: {
      deep: true,
      handler(v, ov) {
        // 触发获取不同地区的用户
        this.$store.commit('changeLocationCity', v);
      }
    },
    placeData: {
      deep: true,
      handler(v, ov) {
        let city = JSON.parse(JSON.stringify(v));
        city.forEach(e => {
          if( e.value == "北京市" || e.value == "天津市" ||  e.value == "上海市" ||  e.value == "重庆市" ||  e.value == "台湾省" || e.value == "香港特别行政区" || e.value == "澳门特别行政区" ){
            let ch = e.children.map(f => f.children);
            e.children = ch[0];
          }else{
            e.children.forEach(f => {
              delete f.children;
            });
          }
          e.children.unshift({"value":"","label":"全部地区"});
        });
        this.cityData = city;
        this.loadingCityData = false;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/selectCity/index.vue